import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    url: String,
    turboFrame: String,
    turboAction: String,
  };

  handleClick(event) {
    // If user clicked on a link, let the browser handle it
    const clickedLink = event.target.closest('a[href]');
    if (clickedLink) {
      // It's a link in the content -> do nothing, browser will navigate
      return;
    }

    // User clicked on content (not a link) -> open post
    event.preventDefault();

    try {
      // Find and trigger the post-dialog controller's show method
      const dialogElement = document.querySelector('[data-controller*="post-dialog"]');

      if (dialogElement && this.application) {
        const postDialogController = this.application.getControllerForElementAndIdentifier(
          dialogElement,
          'post-dialog'
        );

        if (postDialogController && typeof postDialogController.show === 'function') {
          postDialogController.show();
        }
      }

      // Navigate to the post URL using Turbo
      if (this.hasTurboFrameValue && window.Turbo) {
        window.Turbo.visit(this.urlValue, {
          frame: this.turboFrameValue,
          action: this.hasTurboActionValue ? this.turboActionValue : "advance"
        });
      } else {
        window.location.href = this.urlValue;
      }
    } catch (error) {
      // Fallback to direct navigation if something fails
      console.error('Error opening post dialog:', error);
      window.location.href = this.urlValue;
    }
  }
}
